import { clearLinkingPhonePrefill } from "./linking-phone.js";
import {
  clearAllOnboardingAuthDrafts,
  clearOnboardingHandoffToken,
} from "./onboarding-auth.js";
import {
  resetOnboardingDesignState,
} from "./onboarding-design-mode.js";
import { resetPostHogUser } from "./posthog.js";
import { clearPreferencesResumeTarget } from "./preferences-resume.js";
import {
  clearShareLinkEntry,
  clearStoredShareLinkReferrerName,
} from "./share-link-entry.js";

const LINK_SESSION_KEY = "mincool.linkSessionId";
const ACCOUNT_ID_KEY = "mincool.accountId";
const ATTRIBUTION_KEY = "mincool.attributionCode";
const RESPONSE_CACHE_PREFIX = "mincool.apiCache";
const SETUP_PREFERENCE_DRAFT_PREFIX = "mincool.setupPreferenceDraft";

function storageTargets() {
  if (typeof window === "undefined") {
    return [];
  }
  return [window.sessionStorage, window.localStorage].filter(Boolean);
}

function clearStoredKeysWithPrefix(prefix = "") {
  const normalizedPrefix = String(prefix || "").trim();
  if (!normalizedPrefix) {
    return;
  }
  for (const store of storageTargets()) {
    const keysToClear = [];
    for (let index = 0; index < store.length; index += 1) {
      const key = store.key(index);
      if (String(key || "").startsWith(normalizedPrefix)) {
        keysToClear.push(key);
      }
    }
    for (const key of keysToClear) {
      store.removeItem(key);
    }
  }
}

export function clearSignedInBrowserState({
  preserveAttributionCode = true,
  preserveShareLinkEntry = true,
} = {}) {
  for (const store of storageTargets()) {
    store.removeItem(LINK_SESSION_KEY);
    store.removeItem(ACCOUNT_ID_KEY);
    if (!preserveAttributionCode) {
      store.removeItem(ATTRIBUTION_KEY);
    }
  }
  clearStoredKeysWithPrefix(RESPONSE_CACHE_PREFIX);
  clearStoredKeysWithPrefix(SETUP_PREFERENCE_DRAFT_PREFIX);
  clearLinkingPhonePrefill();
  clearPreferencesResumeTarget();
  clearOnboardingHandoffToken();
  clearAllOnboardingAuthDrafts();
  if (!preserveShareLinkEntry) {
    clearShareLinkEntry();
    clearStoredShareLinkReferrerName();
  }
  resetPostHogUser();
}

export function clearOnboardingBrowserState() {
  clearSignedInBrowserState({
    preserveAttributionCode: false,
    preserveShareLinkEntry: false,
  });
  resetOnboardingDesignState();
}
